<style lang="less">

</style>
<template>
	<v-row :class="classes">
		<DisplayColumn v-for="childElement in element.elements" :element="childElement" :key="childElement.id"></DisplayColumn>	
	</v-row>
</template>

<script>
	import DisplayColumn from "../TextEditor/DisplayColumn.vue";
	export default {
		name: "DisplayRow",
		props:{
			element: {type: Object},
		}, 
		components: {
			DisplayColumn
		},
		data: () =>{
			return {			

			}
		},
		computed: {
			bindings(){
				var bindings = {
					id: this.element.id
				}
				return bindings;
			},
			classes(){
				var object = {}
				object[this.element.attrs.padding] = this.element.attrs.padding ? true : false;
				return object;
			},
		}
	}
</script>